// src/config.js
// Suprascrie cu REACT_APP_API_BASE in .env.local
export const API_BASE = process.env.REACT_APP_API_BASE || 'http://localhost:8000';
export const API_ENDPOINT = `${API_BASE}/api/v1`;
// Pasul 37: adresa publica a site-ului — linkurile distribuite (si din APK) duc aici, nu la originea aplicatiei.
export const SITE_PUBLIC = (process.env.REACT_APP_SITE_URL || 'https://artanft.webnou.ro').replace(/\/$/, '');
